/* angular */
import { createAction, props } from '@ngrx/store';

/* action types */
export enum ActionTypes {
  InitApp = '[APP] InitApp',
}

/* actions */

/* This event is fired when the app is started */
export const InitApp = createAction(ActionTypes.InitApp);
